import { z } from 'zod';
export const DSLTermQueryDTO = z.object({
  term: z.record(
    z.string(),
    z.union([
      z.string(),
      z.number(),
      z.boolean(),
      z.object({
        value: z.union([z.string(), z.number(), z.boolean()]),
        boost: z.number().optional(),
      }),
    ]),
  ),
});

export type DSLTermQuery = z.infer<typeof DSLTermQueryDTO>;